import React from "react";
import Button from "../button";

export default function EmptyModal({
	children,
	className,
	classNameChildren,
	open = false,
	onClose,
	width,
	height = "70vh",
}) {
	return (
		<div
			className={`fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center  ${!open ? "hidden" : ""
				} ${className}`}
		>
			<div
				className={`bg-white rounded-lg p-8 laptop:w-4/5 tablet:w-2/3 w-full ${classNameChildren}`}
				style={{ height: height, width: width }}
			>
				{onClose && (
					<div className="w-ful flex flex-row-reverse">
						<i className="fas fa-close cursor-pointer" onClick={onClose}></i>
					</div>
				)}
				<div
					style={{
						height: "100%",
						overflowY: "auto",
					}}
				>
					{children}
				</div>
			</div>
		</div>
	);
}
